import React from 'react';
import { ListSkeleton } from '@/placeholders/skeleton-placeholders/list-skeleton';

const RsGrid = React.lazy(() => import('./rs-grid'));

/**
 * Wrapper around Ag-Grid wrapper component that exits for the sake of
 * making code splitting easy
 *
 * @param {*} props Props for AgGrid
 */
export function AsyncRsGrid(props) {
  return (
    <React.Suspense fallback={<ListSkeleton />}>
      <RsGrid {...props} />
    </React.Suspense>
  );
}
